/**
 * EAkte Plus API
 * API eakteplus document metadata api
 *
 * OpenAPI spec version: 1.0.1
 * Contact: ehgidencores@eulerhermes.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
	HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { DocumentMetadata } from '../model/documentMetadata';
import { FilterDocumentMetadata } from '../model/filterDocumentMetadata';
import { SearchedDocuments } from '../model/searchedDocuments';
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { environment } from '../../environments/environment';
import { Subject } from 'rxjs';

@Injectable()
export class DocumentMetadataService {

	protected basePath = environment.demoApi;
	public defaultHeaders = new HttpHeaders();
	public configuration = new Configuration();

	constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
		if (basePath) {
			this.basePath = basePath;
		}
		if (configuration) {
			this.configuration = configuration;
			this.basePath = basePath || configuration.basePath || this.basePath;
		}
	}

	/**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
	private canConsumeForm(consumes: string[]): boolean {
		const form = 'multipart/form-data';
		for (const consume of consumes) {
			if (form === consume) {
				return true;
			}
		}
		return false;
	}


	/**
     * Return the DocumentMetadata object
     * Get the document metadata for the Document Unique Identifier
     * @param dui Document Unique Identifier
     * @param authorization Security token authenticating a user
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
	public documentMetadataGet(dui: string, observe?: 'body', reportProgress?: boolean): Observable<DocumentMetadata>;
	public documentMetadataGet(dui: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<DocumentMetadata>>;
	public documentMetadataGet(dui: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<DocumentMetadata>>;
	public documentMetadataGet(dui: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
		let headers = this.defaultHeaders;


		// authentication (oauth) required
		if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
			headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
		}

		// to determine the Accept header
		let httpHeaderAccepts: string[] = [
			'application/json'
		];
		const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
		if (httpHeaderAcceptSelected != undefined) {
			headers = headers.set('Accept', httpHeaderAcceptSelected);
		}

		// to determine the Content-Type header
		const consumes: string[] = [
		];

		return this.httpClient.request<DocumentMetadata>('get',`${this.basePath}/documents/${encodeURIComponent(String(dui))}/metadata`,
			{
				withCredentials: this.configuration.withCredentials,
				headers: headers,
				observe: observe,
				reportProgress: reportProgress
			}
		);
	}

	/**
     * Returns the uuid of the SearchFilter
     * Creates a SearchFilter and generates an identifier to use while searching a document metadatas matching the filter criteria
     * @param body
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
	public documentMetadatasCreateSearchFilter(body: FilterDocumentMetadata, observe?: 'body', reportProgress?: boolean): Observable<string>;
	public documentMetadatasCreateSearchFilter(body: FilterDocumentMetadata, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<string>>;
	public documentMetadatasCreateSearchFilter(body: FilterDocumentMetadata, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<string>>;
	public documentMetadatasCreateSearchFilter(body: FilterDocumentMetadata, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
		let headers = this.defaultHeaders;

		// authentication (oauth) required
		if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
			headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
		}

		// to determine the Accept header
		let httpHeaderAccepts: string[] = [
			'application/json'
		];
		const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
		if (httpHeaderAcceptSelected != undefined) {
			headers = headers.set('Accept', httpHeaderAcceptSelected);
		}

		// to determine the Content-Type header
		const consumes: string[] = [
			'application/json'
		];
		const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
		if (httpContentTypeSelected != undefined) {
			headers = headers.set('Content-Type', httpContentTypeSelected);
		}

		return this.httpClient.request<string>('post',`${this.basePath}/documents/searchFilters`,
			{
				body: body,
				withCredentials: this.configuration.withCredentials,
				headers: headers,
				observe: observe,
				reportProgress: reportProgress
			}
		);
	}

	/**
     * Returns a SearchFilter
     * get SearchFilter based on it&#x27;s identifier
     * @param searchFilterId SearchFilter unique id
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
	public documentMetadatasGetSearchFilter(searchFilterId: string, observe?: 'body', reportProgress?: boolean): Observable<FilterDocumentMetadata>;
	public documentMetadatasGetSearchFilter(searchFilterId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<FilterDocumentMetadata>>;
	public documentMetadatasGetSearchFilter(searchFilterId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<FilterDocumentMetadata>>;
	public documentMetadatasGetSearchFilter(searchFilterId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
		let headers = this.defaultHeaders;

		// authentication (oauth) required
		if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
			headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
		}

		// to determine the Accept header
		let httpHeaderAccepts: string[] = [
			'application/json'
		];
		const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
		if (httpHeaderAcceptSelected != undefined) {
			headers = headers.set('Accept', httpHeaderAcceptSelected);
		}

		// to determine the Content-Type header
		const consumes: string[] = [
		];

		return this.httpClient.request<FilterDocumentMetadata>('get',`${this.basePath}/documents/searchFilters/${encodeURIComponent(String(searchFilterId))}`,
			{
				withCredentials: this.configuration.withCredentials,
				headers: headers,
				observe: observe,
				reportProgress: reportProgress
			}
		);
	}


	/**
     * Return the DocumentMetadata objects
     * Search document metadatas which match the filter criteria
     * @param authorization Security token authenticating a user
     * @param body
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
	public documentMetadatasList(body?: FilterDocumentMetadata, observe?: 'body', reportProgress?: boolean): Observable<SearchedDocuments>;
	public documentMetadatasList(body?: FilterDocumentMetadata, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SearchedDocuments>>;
	public documentMetadatasList(body?: FilterDocumentMetadata, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SearchedDocuments>>;
	public documentMetadatasList(body?: FilterDocumentMetadata, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

		let headers = this.defaultHeaders;

		if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
			headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
		}

		// to determine the Accept header
		let httpHeaderAccepts: string[] = [
			'application/json'
		];
		const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
		if (httpHeaderAcceptSelected != undefined) {
			headers = headers.set('Accept', httpHeaderAcceptSelected);
		}

		// to determine the Content-Type header
		const consumes: string[] = [
			'application/json'
		];
		const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
		if (httpContentTypeSelected != undefined) {
			headers = headers.set('Content-Type', httpContentTypeSelected);
		}
		var subject = new Subject<SearchedDocuments>();

		this.httpClient.request<HttpResponse<Object>>('post',`${this.basePath}/documents/metadata/search`,
			{
				body: body,
				withCredentials: this.configuration.withCredentials,
				headers: headers,
				observe: 'response',
			}).subscribe((data: any) => {
			var searchedDocuments: SearchedDocuments = {
				totalItems: data.headers.getAll('Total-Items'),
				documents: data.body
			};
			subject.next(searchedDocuments);
		});
		return subject.asObservable();
	}


	/**
     * Retrieves the list with all existing versions of metadatas for id
     * Retrieves all versions of document metadatas for Document Unique Identifier
     * @param dui Document metadata unique Id
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
	public documentmetadataHistoryGet(dui?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<DocumentMetadata>>;
	public documentmetadataHistoryGet(dui?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<DocumentMetadata>>>;
	public documentmetadataHistoryGet(dui?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<DocumentMetadata>>>;
	public documentmetadataHistoryGet(dui?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
		let headers = this.defaultHeaders;

		// authentication (oauth) required
		if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
			headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
		}

		// to determine the Accept header
		let httpHeaderAccepts: string[] = [
			'application/json'
		];
		const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
		if (httpHeaderAcceptSelected != undefined) {
			headers = headers.set('Accept', httpHeaderAcceptSelected);
		}

		// to determine the Content-Type header
		const consumes: string[] = [
		];

		return this.httpClient.request<Array<DocumentMetadata>>('get',`${this.basePath}/documents/${encodeURIComponent(String(dui))}/metadata/history`,
			{
				withCredentials: this.configuration.withCredentials,
				headers: headers,
				observe: observe,
				reportProgress: reportProgress
			}
		);
	}

	/**
     * Retrieves the version of metadatas for Document Unique Identifier
     * Retrieves the version of document metadata for Document Unique Identifier
     * @param dui Document Unique Identifier
     * @param version Desired version of the metadata history identified by dui
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
	public documentmetadataHistoryGetVersion(dui?: string, version?: string, observe?: 'body', reportProgress?: boolean): Observable<DocumentMetadata>;
	public documentmetadataHistoryGetVersion(dui?: string, version?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<DocumentMetadata>>;
	public documentmetadataHistoryGetVersion(dui?: string, version?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<DocumentMetadata>>;
	public documentmetadataHistoryGetVersion(dui?: string, version?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
		let headers = this.defaultHeaders;

		// authentication (oauth) required
		if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
			headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
		}

		// to determine the Accept header
		let httpHeaderAccepts: string[] = [
			'application/json'
		];
		const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
		if (httpHeaderAcceptSelected != undefined) {
			headers = headers.set('Accept', httpHeaderAcceptSelected);
		}

		// to determine the Content-Type header
		const consumes: string[] = [
		];

		return this.httpClient.request<DocumentMetadata>('get',`${this.basePath}/documents/${encodeURIComponent(String(dui))}/metadata/history/${encodeURIComponent(String(version))}`,
			{
				withCredentials: this.configuration.withCredentials,
				headers: headers,
				observe: observe,
				reportProgress: reportProgress
			}
		);
	}

	/**
     * Put a DocumentMetadata
     * Change/Update the current version of document metadata
     * @param authorization Security token authenticating a user
     * @param dui Document Unique Identifier
     * @param body
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
	public documentmetadataPut(dui?: string, body?: DocumentMetadata, observe?: 'body', reportProgress?: boolean): Observable<DocumentMetadata>;
	public documentmetadataPut(dui?: string, body?: DocumentMetadata, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<DocumentMetadata>>;
	public documentmetadataPut(dui?: string, body?: DocumentMetadata, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<DocumentMetadata>>;
	public documentmetadataPut(dui?: string, body?: DocumentMetadata, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
		let headers = this.defaultHeaders;

		// authentication (oauth) required
		if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
			headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
		}

		// to determine the Accept header
		let httpHeaderAccepts: string[] = [
			'application/json'
		];
		const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
		if (httpHeaderAcceptSelected != undefined) {
			headers = headers.set('Accept', httpHeaderAcceptSelected);
		}

		// to determine the Content-Type header
		const consumes: string[] = [
			'application/json'
		];
		const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
		if (httpContentTypeSelected != undefined) {
			headers = headers.set('Content-Type', httpContentTypeSelected);
		}

		return this.httpClient.request<DocumentMetadata>('put',`${this.basePath}/documents/${encodeURIComponent(String(dui))}/metadata`,
			{
				body: body,
				withCredentials: this.configuration.withCredentials,
				headers: headers,
				observe: observe,
				reportProgress: reportProgress
			}
		);
	}

}
